import { baseUrl, headers, jwtHeaders } from "../common/data";

export const getAllRequests = async () => {
    try {
        const response = await fetch(`${baseUrl}/api/superadmin/getallsubscriptions?status=PENDING`, {
            headers: jwtHeaders(),
        });
        const resData = await response?.json();
       
        return resData;
    } catch (err) {
       
    }
};

export const updateRequest = async (data, id) => {
    try {
        const response = await fetch(`${baseUrl}/api/superadmin/updatesubscription/status/${id}`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify({
                "status": data.toUpperCase()
            })
        });
        const resData = await response?.json();
       
        return resData;
    } catch (err) {
       
    }
};

export const fetchAllSubscription = async () => {
    const response = await fetch(`${baseUrl}/api/subscription/getallsubscription`, {
        method: "GET",
        headers: headers,
        redirect: "follow",
    });
    const resData = await response?.json();
   
    return resData;
};

export const deleteSubscription = async (id) => {
    try {
        const response = await fetch(`${baseUrl}/api/subscription/deletesubscription/${id}`, {
            method: 'DELETE',
            headers: headers,
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};


export const createSubscription = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/subscription/create`, {
            method: 'POST',
            body: data,
            headers: headers
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};

